module.exports = __webpack_public_path__ + "img/3af260bddc7a86f7e459b5a91bfcc683.svg";